module.exports = __webpack_public_path__ + "static/img/banner_03.912e7673.png";